import { JSX } from "react";

import {
  TableControl,
  TableControlLayoutProps,
} from "@plansoft-configuration-renderer/components";

import { TableControl as TableProductFinder } from "./base/index.js";

export const CustomTablesWrapper = (
  props: TableControlLayoutProps,
): JSX.Element => {
  let mode = "custom";
  switch (mode) {
    case "custom":
      return <TableProductFinder {...props} />;

    default:
      return <TableControl {...props} />;
  }
};
